import {initFullPage} from '../full-page-scroll-sections/initFullPage';

document.addEventListener('DOMContentLoaded', function () {
    initFullPage();
  });